import { useQuery } from "@tanstack/react-query";
import { projectDetailsApi } from "../api/projectDetails";

export const useStakeHolderOwnership = ({
    projectId,
    userId
} : {
    projectId: string | undefined;
    userId: number | null
}) => {
    const { data, isFetching, isPending, isError, refetch } = useQuery({
        queryKey: ["stake-holder-ownership", projectId, userId],
        queryFn: () => projectDetailsApi.fetchStakeHolderOwnership({ projectId, userId: userId! }),
        enabled: !!projectId && !!userId,
    });

    return {
        ownershipData: data?.data?.rows || [],
        ownershipCount: data?.data?.count || 0,
        isPending, 
        isFetching, 
        isError,
        refetch
    };
};